export default __webpack_public_path__ + "static/media/file.ab9c0df5.svg";